module.exports = __webpack_public_path__ + "static/media/webform.e4c8504d.svg";